import type { Site } from "../../../utils/backend-types";

/** Finds the corresponding Site for a given siteId and returns the generator name with the site name appended. */
export function getGeneratorNameWithSite(
  generatorName: string,
  siteId: number,
  sites: Array<Site>
) {
  const site = sites.find((site) => site.id === siteId);

  if (site) {
    return `${generatorName} (${site.name})`;
  }

  return generatorName;
}
